module.exports = __webpack_public_path__ + "assets/img/topImg.e3dae8a9.png";